define('views/modules/onboarding/onboarding',[
    'backbone', 'mustache', 'bootbox',
    // services
    'services/user',
    'services/i18n',
    'services/layout',
    // views
    'views/parts/tutorial-box',
    // collections
    'collections/onboarding/tutorials',
    // templates
    'text!templates/modules/onboarding/onboarding.html'
], function(
    Backbone,
    Mustache,
    Bootbox,
    // services
    User,
    I18n,
    LayoutState,
    // views
    VTutorialBox,
    // collections
    COnboardingTutorials,
    // templates
    TOnboarding
) {
    var VOnboarding = Backbone.View.extend({
        template: TOnboarding,

        list: ".onboarding-tutorials-list",

        events: {
            'click .hide-tutorials': 'onHideTutorials',
            'click .menu-mobile-link': 'toggleMenu'
        },

        initialize: function(options) {
            this.profile = User;
            this.collection = COnboardingTutorials;
        },

        render: function() {
            this.$el.addClass('scollable-container');
            this.$el.empty().html(Mustache.render(this.template, Mustache.getContext({
                firstname: this.profile.get('firstname')
            })));
            this.renderAll();
            return this;
        },

        renderAll: function() {
            this.collection.each(this.renderOne.bind(this));
        },

        renderOne: function(model) {
            var view = (new VTutorialBox({
                model: model,
                profile: this.profile
            })).render();
            this.$el.find(this.list).append(view.$el);
        },

        redirect: function() {
            var url = '#/supervisor/group/default/member/me/calendar/';

            if (this.profile.get('isHiddenFromClientsList') && !this.profile.get('_fallbackMemberId')) {
                url = '#/supervisor/group/default/noclient/';
            }

            Backbone.history.navigate(url);
        },

        onHideTutorials: function() {
            Bootbox.confirm({
                title: I18n.t('Hide this page forever'),
                message: I18n.t('Are you sure you wish to hide this page forever?'),
                context: this,
                callback: function(result) {
                    if (result) {
                        this.profile.save({ showOnboarding: false }, { patch: true });
                        this.redirect();
                    }
                }
            })
        },

        toggleMenu: function() {
            LayoutState.toggleMenu();
        }
    });

    return VOnboarding;
});

